<template>
  <div class="rule">
      <div class="deleteButton" @click="deleteRule">
          <i class="fal fa-trash"></i>
      </div>
      <div v-if="type === 'time'">
          <h5>Time rule</h5>
          <table>
              <tr>
                  <td style="width:100px;">
                      <span>From:</span>
                  </td>
                  <td>
                      <input class="timeInput" :name="'rule_' + index + '_time_from'" type="text" maxlength="2" v-model="data.time.from"> : <input class="timeInput" value="00" type="text" readonly>
                  </td>
              </tr>
              <tr>
                  <td>
                      <span>To:</span>
                  </td>
                  <td>
                      <input class="timeInput" :name="'rule_' + index + '_time_to'" type="text" maxlength="2" v-model="data.time.to"> : <input class="timeInput" value="00" type="text" readonly>
                  </td>
              </tr>
          </table>
      </div>
      <div v-else-if="type === 'location'">
          <h5>Location rule</h5>
          <table>
              <tr>
                  <td style="width:100px;">
                      <span>Latitude:</span>
                  </td>
                  <td>
                      <input style="width:150px;" :name="'rule_' + index + '_location_lat'" type="text" v-model="data.location.lat">
                  </td>
              </tr>
              <tr>
                  <td>
                      <span>Longitude:</span>
                  </td>
                  <td>
                      <input style="width:150px;" :name="'rule_' + index + '_location_lon'" type="text" v-model="data.location.lon">
                  </td>
              </tr>
              <tr>
                  <td>
                      <span>Radius:</span>
                  </td>
                  <td>
                      <input style="width:50px;" :name="'rule_' + index + '_location_radius'" type="text" v-model="data.location.radius"> km
                  </td>
              </tr>
          </table>
      </div>
  </div>
</template>

<script>
export default {
    props: {
        index: {
            type: Number,
            required: true
        },
        type: {
            type: String,
            required: true
        },
        existing_data: {
            type: Object,
            default: () => {}
        }
    },
    mounted () {
        if (this.existing_data !== {} && this.existing_data !== undefined) {
            switch(this.type) {
                case "time":
                    this.data.time = this.existing_data;
                    break;
                case "location":
                    this.data.location = this.existing_data;
                    break;
            }
        } else {
            //Set defaults
            switch (this.type) {
                case "time":
                    this.data.time.from = (new Date()).getHours();

                    var addedOneHour = new Date();
                    addedOneHour.setHours(addedOneHour.getHours() + 1);
                    this.data.time.to = addedOneHour.getHours();
                    break;
                case "location":
                    if (navigator.geolocation) {
                        navigator.geolocation.getCurrentPosition(function(position) {
                            this.data.location.lat = position.coords.latitude;
                            this.data.location.lon = position.coords.longitude;
                        }.bind(this));
                    }
                    break;
            }
        }
    },
    data () {
        return {
            data: {
                time: {
                    from: 0,
                    to: 0
                },
                location: {
                    lat: 0,
                    lon: 0,
                    radius: 2
                }
            }
        }
    },
    methods: {
        deleteRule() {
            this.$emit("onDeleteRule", this.index);
        }
    }
}
</script>

<style>
.rule {
    padding-bottom: 20px;
    border-bottom: 1px solid grey;
}
.timeInput {
    width: 50px;
    text-align: center;
}
.deleteButton {
    font-size: 20px;
    float:right;
    margin-right: 20px;
    cursor: pointer;
}
</style>

<style scoped>
h5 {
    margin-bottom: 5px;
}
</style>